import React, { useState } from "react";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import ReclassifyHistoryStore from "../Stores/ReclassifyHistoryStore";
import { useEffect } from "react";
import AcxDataGrid from "components/UI/AcxDataGrid/AcxDataGrid";
import { Grid, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { Link, useSearchParams } from "react-router-dom";
import { AcxTabPanel } from "components/UI/AcxTabPanel";

const primaryPagePadding = 16;

const ReclassifyHistory = observer(() => {
    const store = useStore(ReclassifyHistoryStore);
    // Your Models links here with ?tab=model-builder; everything else opens on RBC
    const [searchParams] = useSearchParams();
    const fromModelBuilder = searchParams.get("tab") === "model-builder";
    const [tab, setTab] = useState(fromModelBuilder ? 1 : 0);

    useEffect(() => {
        store.loadReclassifyResultsV2();
        store.loadReclassifyResultsLlm();
        store.loadReclassifyResults();
    }, [store]);

    return (
        <Grid container direction="column" rowGap={1}>
            <Grid
                container
                item
                sx={(theme) => ({
                    backgroundColor: theme.palette.white.main,
                    borderBottom: `0.5px solid ${theme.palette.neutral[100]}`,
                    paddingInline: theme.spacing(primaryPagePadding),
                    paddingBlock: theme.spacing(2),
                    position: "relative",
                })}
                alignItems="center"
            >
                <Grid item>
                    <Typography
                        display="block"
                        align="left"
                        sx={(theme) => ({
                            fontSize: "18px",
                            lineHeight: "28px",
                            fontWeight: "bold",
                            color: theme.palette.gray[700],
                        })}
                    >
                        Reclassify History
                    </Typography>
                </Grid>
                <Grid
                    item
                    sx={(theme) => ({
                        position: "absolute",
                        left: theme.spacing(primaryPagePadding - 5),
                    })}
                >
                    <Link
                        className="pendo-ignore"
                        to={fromModelBuilder ? "../llm" : "../"}
                    >
                        <IconButton>
                            <ArrowBack />
                        </IconButton>
                    </Link>
                </Grid>
            </Grid>
            <Grid
                item
                width="100%"
                height="80%"
                sx={(theme) => ({
                    padding: theme.spacing(
                        0,
                        primaryPagePadding,
                        10,
                        primaryPagePadding,
                    ),
                })}
            >
                <Tabs
                    value={tab}
                    onChange={(_event, next) => setTab(next)}
                    sx={{ marginBottom: 1 }}
                >
                    <Tab label="RBC" />
                    <Tab label="Model Builder" />
                    <Tab label="Legacy" />
                </Tabs>
                <AcxTabPanel value={tab} index={0} style={{ height: "100%" }}>
                    <AcxDataGrid dataGridStore={store.dataGridV2} />
                </AcxTabPanel>
                <AcxTabPanel value={tab} index={1} style={{ height: "100%" }}>
                    <AcxDataGrid dataGridStore={store.dataGridLlm} />
                </AcxTabPanel>
                <AcxTabPanel value={tab} index={2} style={{ height: "100%" }}>
                    <AcxDataGrid dataGridStore={store.dataGrid} />
                </AcxTabPanel>
            </Grid>
        </Grid>
        // <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
        //     <code>{JSON.stringify(store.reclassifyResults)}</code>
        // </pre>
    );
});

export default ReclassifyHistory;
